export default __webpack_public_path__ + "static/media/week-img.ae526e56.png";